import { Link } from 'gatsby'
import React from 'react'

import footerMap from "../../assets/images/footer-map.png"
import logo from "../../assets/images/logo.png"

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area bg-color">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <a href="/" className="logo">
                                <img src={logo} alt="logo" />
                            </a>
                            <p> Cobranet Limited is a leading internet service and data provider. </p>
                            <h5> Always on the Go</h5>
                            <ul className="social-link">
                                <li>
                                    <Link to="#" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-facebook'></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-twitter'></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-instagram'></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="d-block" target="_blank" rel="noreferrer">
                                        <i className='bx bxl-linkedin'></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Explore</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/about-us">
                                        About
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-residential-details">
                                        Residential Services
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-dedicated-details">
                                        Enterprise Services
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-managed-details">
                                        Solutions & Managed Services
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/profile-authentication">
                                        Login/Register
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact">
                                        Contact
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Lagos</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i>
                                    Plot 8, Rafiu Babatunde St. (Admiralty Road), Off Admiralty way, Lekki Phase 1 <br />
                                    - Lagos Nigeria.
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:02012716269">0201-2716269</a>
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:02019132000">0201-9132000</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Abuja</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i>
                                    Abuja Address: 4th Floor, Church Gate Towers, Plot 473 Constitution Avenue, CBD <br />
                                    - Abuja Nigeria.
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:02012716269">0201-2716269</a>
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:02019132000">0201-9132000</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p>Copyright @{currentYear} <strong>Cobranet</strong> All rights reserved </p>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            {/* <ul>
                                <li>
                                    <Link to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms-of-service">
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul> */}
                            <p>Made with&nbsp;
                                <span role="img" aria-label="Love">&#129505;</span>
                                &nbsp;by&nbsp;
                                <a target="_blank" href="https://solweavers.com/" rel="noreferrer">
                                Solweavers
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-map">
                <img src={footerMap} alt="footer-logo" />
            </div>
        </footer>
    );
}

export default Footer;